import { Box } from '@chakra-ui/react';

import { PageContainer } from '../layout-constants';
import { PublicFooter } from './PublicFooter';
import { PublicHeader } from './PublicHeader';

interface PublicLayoutProps {
  children: React.ReactNode;
  containerClassname?: string;
}

export function PublicLayout({
  children,
  containerClassname,
}: PublicLayoutProps) {
  return (
    <>
      <PublicHeader />
      <Box
        as={PageContainer}
        className={containerClassname}
        px={{ base: 4, md: 8, lg: 12, xl: 16 }}
        pt={8}
        transition="padding .3s"
      >
        {children}
        <PublicFooter />
      </Box>
    </>
  );
}
